// extracted by css-extract-rspack-plugin
export default {"cls1":"common-cls1_EGv","cls2":"common-cls2_1-K common-cls1_EGv"};